import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import styled from "styled-components";
import { AppNoInfo } from "@/layout/AppComponents";
import { useParams } from "react-router-dom";
import { axiosPath } from "../../../routing/helpers/router";
import BreadcrumbHandler from "../../../layout/components/breadcrumb/BreadcrumbHandler";
import ModuleWidgetSwitch from "../../../layout/screenSpecifics/ModuleSelect/ModuleWidgetSwitch";
import colors from "../../../constants/colors";
import useIsMounted from "../../../layout/components/hooks/useIsMounted";

const ModuleBridgeFolderHomeScreen = () => {
  const { moduleBridgeHex } = useParams();
  const isMounted = useIsMounted();
  const [moduleBridgeFolder, setModuleBridgeFolder] = useState();

  // > LOAD MODULEBRIDGEFOLDER
  const loadModuleBridgeFolder = useCallback(async () => {
    setModuleBridgeFolder(null);
    try {
      const response = await axios.post(
        axiosPath("api_r_user_module_moduleBridgeFolder_getModules"),
        { moduleBridgeHex }
      );
      return response.data;
    } catch (err) {}
  });

  useEffect(() => {
    loadModuleBridgeFolder().then((r) => {
      if (isMounted.current) setModuleBridgeFolder(r);
    });
  }, [moduleBridgeHex]);
  // < LOAD MODULEBRIDGEFOLDER

  if (!moduleBridgeFolder) {
    return (
      <div style={{ marginTop: "200px" }}>
        <AppNoInfo />
      </div>
    );
  }

  return (
    <div className="relative m_sr">
      <>
        <BreadcrumbHandler
          paths={[{ name: moduleBridgeFolder.moduleBridge.name }]}
        />
      </>
      <ModuleContainer>
        {moduleBridgeFolder.moduleBridgeFolderGroups?.length > 0 ? (
          <>
            <SquareContainer>
              <div className="grid">
                <div>
                  <ModuleWidgetSwitch />
                </div>
              </div>
            </SquareContainer>
            {moduleBridgeFolder.moduleBridgeFolderGroups.map((fg) => (
              <SquareContainer className="mb-5">
                <h1>{fg.name}</h1>
                <div className="grid">
                  {fg.moduleBridges.map((module) => (
                    <div key={module.hex}>
                      <ModuleWidgetSwitch type={module.name} module={module} />
                    </div>
                  ))}
                </div>
              </SquareContainer>
            ))}
          </>
        ) : (
          <SquareContainer>
            <div className="grid">
              <div>
                <ModuleWidgetSwitch />
              </div>
              {moduleBridgeFolder.moduleBridges.map((module) => (
                <div key={module.hex}>
                  <ModuleWidgetSwitch type={module.name} module={module} />
                </div>
              ))}
            </div>
          </SquareContainer>
        )}
      </ModuleContainer>
    </div>
  );
};

export default ModuleBridgeFolderHomeScreen;

const SquareContainer = styled.div`
  .grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, 200px);
    grid-auto-rows: 250px;
    column-gap: 40px;
    row-gap: 40px;
  }
  .grid::before {
    content: "";
    width: 0;
    padding-bottom: 100%;
    grid-row: 1 / 1;
    grid-column: 1 / 1;
  }

  .grid > *:first-child {
    grid-row: 1 / 1;
    grid-column: 1 / 1;
  }
`;
const ModuleContainer = styled.div`
  margin: 10px 5%;
  h1 {
    font-size: 20px;
    color: ${colors.primary};
    margin: 10px 0;
  }
  img {
    max-width: 100%;
    max-height: 100%;
  }
  .construct {
    padding: 6px;
    border: 2px dashed ${colors.primaryLight};
  }
`;
